import React from 'react';
import topBanner from '../Assets/img/topBanner.png';
import { Link } from 'react-router-dom';

const CancellationandRefund = () => {
  return (
    <>
      <div className='row'>
        <div className='col-md-12'>
          <Link to={`/`} className='btn btn-success btn-sm'>
            <img src={topBanner} alt='Banner' style={{ width: '100%' }} />
          </Link>
        </div>
      </div>

      <div className='container mt-4'>
        <h2>Cancellation & Refund Policy</h2>
        <p>
          At Juice@Home, we strive to deliver freshly made juices directly to your doorstep. As our products are perishable and prepared daily on demand, we maintain a strict cancellation and refund policy.
        </p>
        <h5 className="mt-3">Order Cancellation</h5>
        <ul>
          <li>You may cancel your order up to <strong>12 hours before the scheduled delivery time</strong>.</li>
          <li>Cancellation requests made after this window may not be accepted, as your juice may already be under preparation.</li>
          <li>To cancel, contact our support team via phone or WhatsApp with your order ID.</li>
        </ul>

        <h5 className="mt-4">Refund Policy</h5>
        <ul>
          <li>If your cancellation is approved, the refund will be initiated to the original payment method within <strong>5–7 business days</strong>.</li>
          <li>Refunds will not be issued for missed deliveries due to incorrect address or unavailability of the recipient at the delivery location.</li>
          <li>If there is an issue with the quality of the product received, please contact us immediately for assistance. Refunds or replacements will be handled on a case-by-case basis.</li>
        </ul>

        <p className="mt-3">
          We appreciate your understanding as we aim to minimize waste and maximize freshness.
        </p>
      </div>
    </>
  );
};

export default CancellationandRefund;
